import { useEffect } from "react";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import {
  fetchSetupDefaults,
  fetchSurfaceDefaults,
  fetchTermsAndConditionsDefaults,
} from "../../../redux/proposal-defaults-com-res/action";
import SetupDefaults from "../commercial/setup/SetupDefaults";
import SurfacePreparationsDefault from "../commercial/surface-preparations/SurfacePreparationsDefault";
import DefaultsExterior from "./defaults/DefaultsExterior";
import DefaultsInterior from "./defaults/DefaultsInterior";
import "./ProposalDefaultRes.less";
import TermsAndConditionsDefault from "../commercial/terms-and-conditions/TermsAndConditionsDefault";

type Props = {};

const ProposalDefaultRes = (props: Props) => {
  const dispatch = useDispatch();
  const { setup, surface, termsAndConditions } = useSelector(
    (state: RootStateOrAny) => state.proposalDefaultsComRes
  );
  useEffect(() => {
    dispatch(fetchSetupDefaults("residential"));
    dispatch(fetchSurfaceDefaults("residential"));
    dispatch(fetchTermsAndConditionsDefaults("Residential"));
  }, []);
  return (
    <div>
      <h1 className="pd-commercial-title">Proposal Defaults (residential)</h1>
      <SetupDefaults
        tasks={setup?.filter((item: any) => item.jobType === "interior")}
        type="residential"
        jobType="interior"
      />
      <SetupDefaults
        tasks={setup?.filter((item: any) => item.jobType === "exterior")}
        type="residential"
        jobType="exterior"
      />
      <SurfacePreparationsDefault
        surfaces={surface?.filter((item: any) => item.jobType === "interior")}
        type="residential"
        jobType="interior"
      />
      <SurfacePreparationsDefault
        surfaces={surface?.filter((item: any) => item.jobType === "exterior")}
        type="residential"
        jobType="exterior"
      />
      <TermsAndConditionsDefault
        terms={termsAndConditions}
        type="Residential"
      />
      <DefaultsInterior />
      <DefaultsExterior />
    </div>
  );
};

export default ProposalDefaultRes;
